/**
 * Pre-trowser params: `linkDataModal=true` opened the modal and
 * `linkDataInitialStep` seeded its first step. Opening now goes through the
 * trowser's `modalOpen` param and the step through its `section`, so these are
 * only read — once, to migrate a link minted before the change (see
 * `useMigrateLegacyLinkDataParams`) — and never written.
 */
export const LEGACY_LINK_DATA_MODAL_PARAM = 'linkDataModal';
export const LEGACY_LINK_DATA_INITIAL_STEP_PARAM = 'linkDataInitialStep';
